import React, { useEffect, useRef, useState } from 'react';

import './styles.css';
import { useAuthStore } from '../../../../../store/auth/auth';
import { useNavigate } from 'react-router-dom';
import { Form, message } from 'antd';

import { DeleteLayouts } from '../../../../../api/layout/DeleteLayout';
import MainMenu from '../../../../../components/menu/Menu';

import { Header } from 'antd/lib/layout/layout';
import { useLayoutsStore } from './api/layout/useLayoutsStore';
import { useStateNameDevice } from './api/layout/useStateNameDevice';
import { useIsLayoutFormChanged } from './api/layout/useIsLayoutFormChanged';
import LocationMap2 from '../../../../../components/locationMap2/LocationMap2';
import { UpdateLayouts } from '../../../../../api/layout/UpdateLayout';
import { Device } from '../../../../../types/Device';
import DevicePositionModal from './components/DevicePosition/DevicePosition';
import useRecordingStore from './api/recording/recordingStore';
import { RecordModal } from './components/modals/RecordModal/RecordModal';
import { RecordingTimers } from './components/RecordingTimers/RecordingTimers';
import { StopRecordingModal } from './components/modals/StopRecordingModal/StopRecordingModal';
import useNotification from '../../../../../utils/features/hooks/useNotification';
import { DeleteLayoutModal } from './components/modals/DeleteLayoutModal/DeleteLayoutModal';
import { CameraGrid } from './components/CameraTile/CameraTile';
import { arraysEqual } from '../../../../../utils/shared/helpers/arraysEqual';
import { SaveDataModal } from './components/modals/SaveDataModal/SaveDataModal';
import { getMaxDevicesForLayoutType } from './helpers/getMaxDevicesForLayoutType';
import { EditGridLayoutModal } from './components/modals/EditGridLayoutModal/EditGridLayoutModal';
import { getSuitableLayoutType } from './helpers/getSuitableLayoutType';
import LayoutControls from './components/LayoutV2Components/LayoutControls/LayoutControls';
import LayoutHeader from './components/LayoutV2Components/Header/Header';
import { useSelectedLayout } from '../../../../../store/useSelectedLayout';
import { takePhotos } from './api/recording/recordingApi';
import { DeviceByGroupStore } from '../../../../../store/devices/DeviceByGroupStore';

type LayoutViewType = '2x2' | '1х5' | '3х4' | '3х3' | '2х8' | '1х12' | '4х4' | '1х7';

const LayoutV2 = () => {
    const { SmartDVRToken, user } = useAuthStore();
    const navigate = useNavigate();
    const [formLeft] = Form.useForm();
    const [currentMenuItem, setCurrentMenuItem] = useState('layouts');
    const { fetchLayouts } = useLayoutsStore();
    const [deleteLayoutModal, setDeleteLayoutModal] = useState(false);
    const { setIsShowNameDevice } = useStateNameDevice();
    const [messageApi, messageContextHolder] = message.useMessage();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { selectedLayout, setSelectedLayout } = useSelectedLayout();
    const [isEdit, setIsEdit] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState<Device | null>(null);
    const { fetchAllDevices } = DeviceByGroupStore();
    const {
        setIsAudioModalVisible,
        isAudioModalVisible,
        setIsVideoModalVisible,
        isVideoModalVisible,
        setIsPhotoModalVisible,
        isPhotoModalVisible,
        setIsStopModalVisible,
        isStopModalVisible,
        setStopType,
        stopType,
        startRecording,
        stopRecording,
    } = useRecordingStore();

    const { showNotification, contextHolderr } = useNotification();
    const [devices, setDevices] = useState<Device[]>(selectedLayout?.devices || []);
    const { layoutViewType, setLayoutViewType, pendingChanges, setPendingChanges } =
        useIsLayoutFormChanged();
    const [initialLayoutViewType, setInitialLayoutViewType] = useState<LayoutViewType>('3х3');
    const [initialDevices, setInitialDevices] = useState<Device[]>([]);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const wasEdit = useRef(false);

    const [showExitConfirmModal, setShowExitConfirmModal] = useState(false);
    const [showLayoutChangeConfirm, setShowLayoutChangeConfirm] = useState(false);
    const [layoutToChange, setLayoutToChange] = useState<LayoutViewType | null>(null);
    const [isMapVisible, setIsMapVisible] = useState(false);

    useEffect(() => {
        if (user) {
            fetchAllDevices(SmartDVRToken, user.login);
        }
    }, [SmartDVRToken, fetchAllDevices, user]);

    const handleDragEnd = (newDevices: Device[]) => {
        if (!selectedLayout) return;

        const hasChanged =
            !arraysEqual(newDevices, initialDevices) || layoutViewType !== initialLayoutViewType;

        setDevices(newDevices);
        setSelectedLayout({
            ...selectedLayout,
            viewType: layoutViewType,
            devices: newDevices,
        });

        setHasUnsavedChanges(hasChanged);
    };

    const handlePositionChange = (oldIndex: number, newIndex: number) => {
        if (!selectedLayout) return;
        const newDevices = [...selectedLayout?.devices];
        // Меняем местами устройства
        [newDevices[oldIndex], newDevices[newIndex]] = [newDevices[newIndex], newDevices[oldIndex]];
        console.log('newDevices', newDevices);

        // Обновляем состояние раскладки
        setSelectedLayout({
            ...selectedLayout,
            viewType: layoutViewType,
            devices: newDevices,
        });

        // Обновляем локальное состояние devices
        setDevices(newDevices);
        setHasUnsavedChanges(!arraysEqual(newDevices, initialDevices));
    };

    const handleExitEditMode = () => {
        const hasDeviceChanges = !arraysEqual(devices, initialDevices) || pendingChanges !== null;

        const hasLayoutTypeChanges = layoutViewType !== initialLayoutViewType;

        if (hasDeviceChanges || hasLayoutTypeChanges) {
            setShowExitConfirmModal(true);
        } else {
            setIsEdit(false);
            setLayoutViewType(initialLayoutViewType);
        }
    };

    useEffect(() => {
        if (isEdit && !wasEdit.current && selectedLayout) {
            const layoutDevices = [...(selectedLayout.devices || [])];
            setInitialDevices(layoutDevices);
            setDevices(layoutDevices);
            const viewType = (selectedLayout.viewType || '3х3') as LayoutViewType;
            setInitialLayoutViewType(viewType);
            setLayoutViewType(viewType);
            setHasUnsavedChanges(false);
        }
        wasEdit.current = isEdit;
    }, [isEdit, selectedLayout, setLayoutViewType]);

    useEffect(() => {
        if (!selectedLayout || isEdit) return;

        const deviceCount = selectedLayout.devices?.length ?? 0;
        const currentViewType = selectedLayout.viewType || '3х3';
        const maxForCurrent = getMaxDevicesForLayoutType(currentViewType);

        if (deviceCount <= maxForCurrent) return;

        const suitableType = getSuitableLayoutType(deviceCount);
        if (suitableType === currentViewType) return;

        const updatedLayout = {
            ...selectedLayout,
            viewType: suitableType,
        };

        setSelectedLayout(updatedLayout);
        setLayoutViewType(suitableType);

        UpdateLayouts(SmartDVRToken, user?.login ?? '', {
            uid: selectedLayout.uid,
            viewType: suitableType,
            devices: selectedLayout.devices?.map((device: Device) => ({ UID: device.UID })),
        })
            .then(() => {
                showNotification(
                    'info',
                    'Тип раскладки изменен',
                    `Автоматически выбран тип "${suitableType}" для ${deviceCount} устройств`,
                );
            })
            .catch((error) => {
                console.error('Ошибка сохранения типа раскладки:', error);
            });
    }, [
        SmartDVRToken,
        isEdit,
        selectedLayout,
        setLayoutViewType,
        setSelectedLayout,
        showNotification,
        user?.login,
    ]);

    useEffect(() => {
        if (!selectedLayout) {
            fetchLayouts();
        }
    }, [fetchLayouts, selectedLayout]);

    const handleMenuClick = (key: string) => {
        setCurrentMenuItem(key);
    };

    const handleShowMap = async () => {
        setIsMapVisible(!isMapVisible);
    };

    const handleDeleteLayout = async () => {
        if (!selectedLayout?.uid) {
            console.error('No layout selected for deletion.');
            return;
        }

        try {
            if (!SmartDVRToken || !user) {
                console.error('Missing authentication data.');
                return;
            }

            const deleteData = { uid: selectedLayout?.uid };

            const response = await DeleteLayouts(SmartDVRToken, user.login, deleteData);

            if (response) {
                console.log('Layout deleted successfully:', response);
                // Обновляем список раскладок
                fetchLayouts();
                localStorage.removeItem('selectedLayout');
                // Сбрасываем выбранную раскладку
                setSelectedLayout(null);
                navigate('/layouts');
            } else {
                console.error('Failed to delete layout.');
            }
        } catch (error) {
            console.error('Error during layout deletion:', error);
        }
    };

    // Обработчик для фото
    const handleTakePhoto = async (selectedDevices: Device[]) => {
        try {
            const onlineDevices = selectedDevices.filter((device) => device.online);
            if (onlineDevices.length === 0) {
                showNotification('error', 'Ошибка', 'Нет онлайн устройств для фото');
                return;
            }

            await takePhotos(onlineDevices.map((device) => device.UID));
            showNotification('success', 'Файлы записаны', 'Сохранены фото');
        } catch (error) {
            console.error('Error taking photos:', error);
            showNotification('error', 'Ошибка', 'Не удалось сделать фото');
        }
    };

    const handleStopRecording = async (type: 'audio' | 'video' | 'photo', devices: Device[]) => {
        try {
            if (type === 'photo') {
                // Для фото остановка не требуется
                return;
            }

            await stopRecording(type, devices);

            // Обновляем статусы устройств
            const updatedDevices = selectedLayout?.devices?.map((device: Device) => {
                if (devices.some((selectedDevice) => selectedDevice.UID === device.UID)) {
                    return {
                        ...device,
                        currentStatus:
                            type === 'audio' ? 'остановка аудио записи' : 'остановка видео записи',
                    };
                }
                return device;
            });

            setSelectedLayout({
                ...selectedLayout,
                devices: updatedDevices,
            });
            showNotification(
                'success',
                'Файлы записаны',
                `Сохранены ${type === 'audio' ? 'аудио' : 'видео'}`,
            );
        } catch (error) {
            console.error('Error stopping recording:', error);
            showNotification(
                'error',
                'Ошибка',
                `Не удалось остановить запись ${type === 'audio' ? 'аудио' : 'видео'}`,
            );
        }
    };

    const handleStartRecording = async (type: 'audio' | 'video', devices: Device[]) => {
        const onlineDevices = devices.filter((device) => device.online);

        if (onlineDevices.length === 0) {
            showNotification('error', 'Ошибка', 'Нет онлайн устройств для записи');
            return false; // Возвращаем false, чтобы модалка не открывалась
        }

        try {
            await startRecording(type, onlineDevices);

            // Обновляем статусы устройств
            const updatedDevices = selectedLayout?.devices?.map((device: Device) => {
                if (onlineDevices.some((onlineDevice) => onlineDevice.UID === device.UID)) {
                    return {
                        ...device,
                        currentStatus: type === 'audio' ? 'пишет аудио' : 'пишет видео',
                    };
                }
                return device;
            });

            setSelectedLayout({
                ...selectedLayout,
                devices: updatedDevices,
            });

            showNotification(
                'warning',
                'Запись файла',
                `Ведется запись ${
                    type === 'audio' ? 'аудио' : 'видео'
                } на "${selectedLayout?.name}"`,
            );
            return true;
        } catch (error) {
            showNotification(
                'error',
                'Ошибка',
                `Не удалось начать запись ${type === 'audio' ? 'аудио' : 'видео'}`,
            );
            return false;
        }
    };

    const handleBackToAllDevice = () => {
        navigate('/layouts');
    };

    const handleSelectLayoutView = (size: LayoutViewType) => {
        if (!selectedLayout) return;

        const maxDevices = getMaxDevicesForLayoutType(size);
        const currentDevices = selectedLayout.devices || [];
        if (currentDevices.length > maxDevices) {
            setLayoutToChange(size);
            setShowLayoutChangeConfirm(true);
            return;
        }

        setLayoutViewType(size);
        setHasUnsavedChanges(size !== initialLayoutViewType);
        setSelectedLayout({
            ...selectedLayout,
            viewType: size,
        });
    };

    const confirmLayoutChange = () => {
        if (!layoutToChange || !selectedLayout) return;

        const maxDevices = getMaxDevicesForLayoutType(layoutToChange);
        const newDevices = [...selectedLayout.devices].slice(0, maxDevices);

        setDevices(newDevices);
        setSelectedLayout({
            ...selectedLayout,
            viewType: layoutToChange,
            devices: newDevices,
        });

        setLayoutViewType(layoutToChange);
        setHasUnsavedChanges(true);
        setShowLayoutChangeConfirm(false);
    };

    const handleLayoutSave = async () => {
        if (!user?.login) {
            messageApi.error('Пользователь не авторизован');
            return;
        }

        try {
            const formValues = await formLeft.validateFields();
            const layoutDevices = devices;
            const hasChanges =
                formValues.name !== selectedLayout?.name ||
                formValues.description !== selectedLayout?.description ||
                !arraysEqual(layoutDevices, selectedLayout?.devices || []) ||
                layoutViewType !== selectedLayout?.viewType;

            if (!hasChanges && !pendingChanges && !hasUnsavedChanges) {
                setIsEdit(false);
                return;
            }

            if (!selectedLayout?.uid || !SmartDVRToken) {
                messageApi.error('UID или SmartDVRToken отсутствует.');
                return;
            }

            const updatedLayoutData = {
                ...selectedLayout,
                ...formValues,
                viewType: layoutViewType,
                devices: layoutDevices,
            };

            const response = await UpdateLayouts(SmartDVRToken, user.login, {
                uid: selectedLayout.uid,
                name: updatedLayoutData.name,
                description: updatedLayoutData.description,
                viewType: layoutViewType,
                devices: layoutDevices.map((device: Device) => ({ UID: device.UID })),
            });

            if (response?.success) {
                messageApi.success('Раскладка успешно обновлена');
                setSelectedLayout(updatedLayoutData);
                setHasUnsavedChanges(false);
                setIsEdit(false);
                setPendingChanges(null);
                navigate(`/layout/${selectedLayout.uid}`, {
                    state: { layout: updatedLayoutData },
                });
                return;
            }

            const errorMessage = response?.error || 'Неизвестная ошибка';
            messageApi.error('Ошибка обновления: ' + errorMessage);
        } catch (error) {
            console.error('Ошибка валидации или сохранения:', error);
            messageApi.error('Ошибка валидации или сохранения');
        }
    };

    const handleConfirmExit = async () => {
        setShowExitConfirmModal(false);
        await handleLayoutSave();
    };

    const handleCancelExit = () => {
        if (!selectedLayout) {
            setIsEdit(false);
            setHasUnsavedChanges(false);
            setShowExitConfirmModal(false);
            return;
        }

        setDevices([...initialDevices]);
        setSelectedLayout({
            ...selectedLayout,
            viewType: initialLayoutViewType,
            devices: [...initialDevices],
        });
        setLayoutViewType(initialLayoutViewType);
        setIsEdit(false);
        setHasUnsavedChanges(false);
        setShowExitConfirmModal(false);
    };

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                }}
            >
                <div className="menu">
                    <MainMenu onClick={handleMenuClick} currentMenuItem={currentMenuItem} />
                </div>
            </Header>
            <div
                style={{
                    display: 'flex',
                    height: '100vh',
                }}
            >
                <div
                    className="layouts"
                    style={{ display: 'flex', padding: 24, flex: 1, overflow: 'hidden' }}
                >
                    <LayoutHeader
                        isEdit={isEdit}
                        handleBackToAllDevice={handleBackToAllDevice}
                        handleExitEditMode={handleExitEditMode}
                        isMapVisible={isMapVisible}
                        devices={selectedLayout?.devices ?? []}
                        onShowMap={handleShowMap}
                        handleSelectLayoutView={handleSelectLayoutView}
                    />
                    <div
                        className="body_layouts"
                        style={{
                            flex: 1,
                            overflow: 'hidden',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {selectedLayout ? (
                            <div
                                style={{
                                    flex: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    overflow: 'hidden',
                                }}
                            >
                                <CameraGrid
                                    viewType={selectedLayout.viewType || '3х3'}
                                    devices={selectedLayout.devices || []}
                                    setDevices={handleDragEnd}
                                    menuType={isEdit ? 'edit' : 'layout'}
                                    setIsModalVisible={setIsModalVisible}
                                    setSelectedDevice={setSelectedDevice}
                                    onTileClick={(index: number) => {
                                        if (isEdit) {
                                            setSelectedDevice(selectedLayout.devices[index] ?? null);
                                        }
                                    }}
                                    layout={selectedLayout}
                                />
                            </div>
                        ) : (
                            <p>Раскладка не выбрана</p>
                        )}
                    </div>
                    <LayoutControls
                        selectedLayout={selectedLayout}
                        formLeft={formLeft}
                        handleLayoutSave={handleLayoutSave}
                        isEdit={isEdit}
                        setDeleteLayoutModal={setDeleteLayoutModal}
                        setIsEdit={setIsEdit}
                        setIsShowNameDevice={setIsShowNameDevice}
                    />
                </div>
                {isMapVisible && (
                    <div
                        style={{
                            marginTop: 24, // Отступ от камер
                        }}
                    >
                        <div className={'headline small mapText'}>Карта</div>
                        <LocationMap2 devices={selectedLayout?.devices || []} />
                    </div>
                )}
            </div>
            {messageContextHolder}
            {contextHolderr}
            <EditGridLayoutModal
                visible={showLayoutChangeConfirm}
                onOk={confirmLayoutChange}
                onCancel={() => setShowLayoutChangeConfirm(false)}
                title="Изменение типа раскладки"
                setIsModalVisible={setShowLayoutChangeConfirm}
                layoutName={selectedLayout?.name || ''}
            />

            <SaveDataModal
                visible={showExitConfirmModal}
                onOk={handleConfirmExit}
                onCancel={handleCancelExit}
                title="Несохраненные изменения"
                setIsModalVisible={setShowExitConfirmModal}
                layoutName={selectedLayout?.name || ''}
            />

            <DevicePositionModal
                visible={isModalVisible}
                onOk={() => setIsModalVisible(false)}
                onCancel={() => setIsModalVisible(false)}
                currentPosition={devices.findIndex((device) => device.UID === selectedDevice?.UID)}
                devices={selectedLayout?.devices || []}
                currentDevice={selectedDevice}
                layoutViewType={selectedLayout?.viewType}
                setIsModalVisible={setIsModalVisible}
                onPositionChange={handlePositionChange}
            />

            <RecordModal
                visible={isAudioModalVisible}
                onCancel={() => setIsAudioModalVisible(false)}
                devices={devices}
                onOk={(selectedDevices) => {
                    handleStartRecording('audio', selectedDevices);
                    setIsAudioModalVisible(false);
                }}
                layoutViewType={selectedLayout?.viewType}
                title="Запись аудио"
                type="audio"
                setIsModalVisible={setIsVideoModalVisible}
            />
            <RecordModal
                visible={isVideoModalVisible}
                onCancel={() => setIsVideoModalVisible(false)}
                devices={devices}
                onOk={(selectedDevices) => {
                    handleStartRecording('video', selectedDevices);
                    setIsVideoModalVisible(false);
                }}
                layoutViewType={selectedLayout?.viewType}
                title="Запись видео"
                type="video"
                setIsModalVisible={setIsVideoModalVisible}
            />
            <RecordModal
                visible={isPhotoModalVisible}
                onCancel={() => setIsPhotoModalVisible(false)}
                devices={devices}
                onOk={(selectedDevices) => {
                    handleTakePhoto(selectedDevices);
                    setIsPhotoModalVisible(false);
                }}
                layoutViewType={selectedLayout?.viewType}
                title="Сделать фото"
                type="photo"
                setIsModalVisible={setIsPhotoModalVisible}
            />

            <DeleteLayoutModal
                title={'Удаление раскладки'}
                onCancel={() => setDeleteLayoutModal(false)}
                setIsModalVisible={setDeleteLayoutModal}
                onOk={() => handleDeleteLayout()}
                visible={deleteLayoutModal}
                layoutName={selectedLayout?.name}
            />

            <RecordingTimers
                setIsStopModalVisible={setIsStopModalVisible}
                setStopType={setStopType}
                // setCurrentRecording={setCurrentRecording}
            />

            <StopRecordingModal
                visible={isStopModalVisible}
                onCancel={() => setIsStopModalVisible(false)}
                devices={selectedLayout?.devices || []}
                layoutViewType={selectedLayout?.viewType}
                onOk={(selectedDevices) => {
                    handleStopRecording(stopType, selectedDevices);
                    setIsStopModalVisible(false);
                }}
                setIsModalVisible={setIsStopModalVisible}
                title={`Остановить запись ${stopType === 'audio' ? 'аудио' : 'видео'}`}
                type={stopType}
                // recording={currentRecording!}
            />
        </div>
    );
};

export default LayoutV2;
